import { render, staticRenderFns } from "./NewDetailViewVideo.vue?vue&type=template&id=441202ac&scoped=true&"
import script from "./NewDetailViewVideo.vue?vue&type=script&lang=js&"
export * from "./NewDetailViewVideo.vue?vue&type=script&lang=js&"
import style0 from "./NewDetailViewVideo.vue?vue&type=style&index=0&id=441202ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "441202ac",
  null
  
)

export default component.exports